import { IAllContextsProps } from '../constants/interfaces';
import { trackPasswordViewed } from '../tracking/login';

export const viewPasswordAction = ({
    contexts,
}: {
    contexts: IAllContextsProps;
}) => {
    const analytics = contexts.configContext?.analytics;
    const socialProvider = contexts.userContext?.state.socialProvider ?? '';

    trackPasswordViewed({ socialProvider, analytics });
};
